import i18n from "../i18n";
import {AxiosError} from "axios";

type ErrorResponse = {
    type?: string;
    title?: string;
    status?: number;
    detail?: string;
    instance?: string;
    errorId?: string;
    code?: string;
};

const errorMessageKeys: Record<string, string> = {
    GENERIC_ERROR: 'errors.GENERIC_ERROR',

    // === USER ===
    USER_EMAIL_NOT_FOUND: 'errors.USER_EMAIL_NOT_FOUND',
    USER_NOT_FOUND: 'errors.USER_NOT_FOUND',
    USER_EMAIL_ALREADY_EXISTS: 'errors.USER_EMAIL_ALREADY_EXISTS',
    USER_ACCOUNT_NOT_ACTIVATED: 'errors.USER_ACCOUNT_NOT_ACTIVATED',
    USER_ACCOUNT_ALREADY_ACTIVATED: 'errors.USER_ACCOUNT_ALREADY_ACTIVATED',
    ACCOUNT_ALREADY_ACTIVATED: 'errors.ACCOUNT_ALREADY_ACTIVATED',
    INVALID_CURRENT_PASSWORD: 'errors.INVALID_CURRENT_PASSWORD',
    LAST_SYSTEM_ADMIN_ROLE_CHANGE_FORBIDDEN: 'errors.LAST_SYSTEM_ADMIN_ROLE_CHANGE_FORBIDDEN',

    // === ACTIVATION ===
    INVALID_ACTIVATION_TOKEN: 'errors.INVALID_ACTIVATION_TOKEN',
    ACTIVATION_TOKEN_EXPIRED: 'errors.ACTIVATION_TOKEN_EXPIRED',

    // === PASSWORD RESET ===
    RESET_TOKEN_NOT_FOUND: 'errors.RESET_TOKEN_NOT_FOUND',
    RESET_TOKEN_EXPIRED: 'errors.RESET_TOKEN_EXPIRED',

    // === GROUPS & ROLES ===
    CANNOT_DELETE_GROUP_ALL: 'errors.CANNOT_DELETE_GROUP_ALL',
    CANNOT_ADD_USERS_TO_GROUP_ALL: 'errors.CANNOT_ADD_USERS_TO_GROUP_ALL',
    CANNOT_REMOVE_USERS_FROM_GROUP_ALL: 'errors.CANNOT_REMOVE_USERS_FROM_GROUP_ALL',
    CANNOT_MODIFIED_USERS_FROM_GROUP_ALL: 'errors.CANNOT_MODIFIED_USERS_FROM_GROUP_ALL',
    GROUP_NOT_FOUND: 'errors.GROUP_NOT_FOUND',
    GROUP_ALREADY_EXISTS: 'errors.GROUP_ALREADY_EXISTS',
    ROLE_NOT_FOUND: 'errors.ROLE_NOT_FOUND',

    // === FILES ===
    UNSUPPORTED_FILE_TYPE: 'errors.UNSUPPORTED_FILE_TYPE',
    FILE_TOO_LARGE: 'errors.FILE_TOO_LARGE',

    // === CONTACT ===
    CONTACT_SUBMISSION_NOT_FOUND: 'errors.CONTACT_SUBMISSION_NOT_FOUND',
    CONTACT_SUBMISSION_ATTACHMENT_NOT_FOUND: 'errors.CONTACT_SUBMISSION_ATTACHMENT_NOT_FOUND',

    // === DOCUMENTS & COLLECTIONS ===
    DOCUMENT_NOT_FOUND: 'errors.DOCUMENT_NOT_FOUND',
    DOCUMENT_COLLECTION_NOT_FOUND: 'errors.DOCUMENT_COLLECTION_NOT_FOUND',
    DOCUMENT_COLLECTION_ALREADY_EXISTS: 'errors.DOCUMENT_COLLECTION_ALREADY_EXISTS',
    USER_CANNOT_MODIFIED_DOCUMENT_COLLECTION: 'errors.USER_CANNOT_MODIFIED_DOCUMENT_COLLECTION',
    USER_CANNOT_REMOVE_DOCUMENT_COLLECTION: 'errors.USER_CANNOT_REMOVE_DOCUMENT_COLLECTION',
    COLLECTION_UPDATE_NOT_ALLOWED: 'errors.COLLECTION_UPDATE_NOT_ALLOWED',
    DOCUMENT_THUMBNAIL_NOT_FOUND: 'errors.DOCUMENT_THUMBNAIL_NOT_FOUND',
    COLLECTION_ACCESS_FORBIDDEN: 'errors.COLLECTION_ACCESS_FORBIDDEN',

    // === CONVERSATION ===
    CONVERSATION_NOT_FOUND: 'errors.CONVERSATION_NOT_FOUND',
    NOT_COLLECTIONS_ASSIGNED_TO_CONVERSATION: 'errors.NOT_COLLECTIONS_ASSIGNED_TO_CONVERSATION',
    NOT_PERMISSION_TO_CONVERSATION: 'errors.NOT_PERMISSION_TO_CONVERSATION',
    CHATBOT_RESPONSE_NOT_FOUND: 'errors.CHATBOT_RESPONSE_NOT_FOUND',

    // === PROMPT_TEMPLATE ===
    PROMPT_TEMPLATE_NOT_FOUND: 'errors.PROMPT_TEMPLATE_NOT_FOUND',

    // === TRANSACTION ===
    TRANSACTION_NOT_FOUND: 'errors.TRANSACTION_NOT_FOUND',

    // === JOBS ===
    JOB_NOT_FOUND: 'errors.JOB_NOT_FOUND',
};

export function parseError(error: unknown): string {

    if (typeof error === 'object' && error !== null && 'response' in error) {
        const anyErr = error as AxiosError<ErrorResponse>;
        const status = anyErr.response?.status;

        if (anyErr.response?.data) {
            const errData = anyErr.response.data;

            if (errData.code && errorMessageKeys[errData.code]) {
                return i18n.t(errorMessageKeys[errData.code]);
            }
        }

        if (status === 401) {
            return '';
        }
        if (status === 403) {
            return i18n.t('errors.FORBIDDEN');
        }
    }

    return i18n.t(errorMessageKeys.GENERIC_ERROR);
}
